import { inject, Injectable } from "@angular/core";

import { Settings } from "@hermes/core-app-core";

import { LOADER_RANDOM_IMAGE_COUNT } from "./loader.constants";

@Injectable({ providedIn: "root" })
export class LoaderService {
    private readonly settings = inject(Settings);

    public getAllLoaderImageUrls(): string[] {
        const urls: string[] = [];

        for (
            let imageNumber = 0;
            imageNumber < LOADER_RANDOM_IMAGE_COUNT;
            imageNumber++
        ) {
            urls.push(this.getLoaderImageUrl(imageNumber));
        }

        return urls;
    }

    public getLoaderImageUrl(imageIdentifier: number) {
        return `${this.settings.assetsUrlEditoContent}/Loader/loader-${imageIdentifier}.gif`;
    }
}
